import FullPageLoader from '@/components/FullPageLoader';
import { acceptInvitation } from '@/core/invitation';
import { getToken } from '@/core/token';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export default function InvitationPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('auth');

  const searchParams = new URLSearchParams(window.location.search);
  const invitation = searchParams.get('invitation');
  const firstname = searchParams.get('firstname');
  const lastname = searchParams.get('lastname');
  const redir = searchParams.get('redir') || '/auth/register';
  const jwtToken = getToken();

  const _params = new URLSearchParams();
  _params.set('invitation', invitation || '');
  _params.set('firstname', firstname || '');
  if (lastname) _params.set('lastname', lastname);
  _params.set('redir', redir);

  const redirectUri = `${redir}?${_params.toString()}`;
  const { isLoading } = useQuery({
    queryKey: ['acceptInvitation', invitation],
    queryFn: async () => {
      if (!invitation) {
        toast.error(t('invitation.invalidLink'), {
          description: t('invitation.invalidDescription'),
        });
        return navigate('/auth/login');
      }

      if (jwtToken) navigate(await acceptInvitation(invitation));
      else navigate(redirectUri);

      return null;
    },
    enabled: !!invitation,
  });

  if (isLoading) {
    return (
      <FullPageLoader title={t('invitation.accepting')} subtitle={t('invitation.acceptingDescription')} />
    );
  }

  return <FullPageLoader title={t('invitation.processing')} subtitle={t('invitation.pleaseWait')} />;
}
